var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.onResize,
      expression: "onResize"
    }]
  }, [_c('v-bottom-sheet', {
    attrs: {
      "inset": !_vm.isBreakpointOrDown,
      "scrollable": "",
      "persistent": "",
      "fullscreen": _vm.isBreakpointOrDown
    },
    model: {
      value: _vm.sheet,
      callback: function callback($$v) {
        _vm.sheet = $$v;
      },
      expression: "sheet"
    }
  }, [_c('v-card', {
    attrs: {
      "elevation": 0
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.currentStep === 1 && _vm.hasEditableTokens ? _vm.$t("sign.SignFormEditorControls.fillFields") : _vm.$t("sign.SignFormEditorControls.title")) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.sheet = false;
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-close ")])], 1)], 1), _vm.currentStep === 1 && _vm.hasEditableTokens ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.$t("sign.SignFormEditorControls.fillFieldsSubtitle")) + " ")]) : !_vm.isXsBreakpointOrDown ? _c('v-card-subtitle', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.privacy'))
    }
  }), _vm.partner && _vm.partner.settings && _vm.partner.settings.agbUrl.link ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('sign.Sign.terms', {
        agb: _vm.partner.settings.agbUrl.link
      }))
    }
  }) : _c('span', [_vm._v(".")])]) : _vm._e(), _c('v-progress-linear', {
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "indeterminate": _vm.isGenerationLoading
    }
  }), _vm.currentStep === 1 && _vm.hasEditableTokens ? _c('v-card-text', {
    staticClass: "pt-4"
  }, [_vm.sheet && _vm.currentStep === 1 && _vm.signRequest ? [_c('sign-form-editor-input-list', {
    attrs: {
      "currentPageNumber": _vm.currentPageNumber,
      "signRequest": _vm.signRequest,
      "highlightToken": false
    },
    on: {
      "setCurrentPage": _vm.setCurrentPage
    }
  })] : !_vm.signRequest ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()], 2) : _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('sign.Sign.firstName'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "firstName", $$v);
      },
      expression: "signature.firstName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('sign.Sign.lastName'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "lastName", $$v);
      },
      expression: "signature.lastName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('sign.Sign.location'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.location,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "location", $$v);
      },
      expression: "signature.location"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "mx-auto",
    style: _vm.widthStyle
  }, [_c('div', {
    style: "height: ".concat(_vm.heightSignature, "; ").concat(_vm.widthStyle, ";")
  }, [_c('span', {
    staticClass: "overlay",
    staticStyle: {
      "z-index": "1"
    },
    style: _vm.overlayStyle
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.signOverlay")) + " ")]), _c('vue-signature-pad', {
    key: "i-am-a-frustrating-pad-and-only-work-when-this-frigging-key-switches-".concat(_vm.signPadMotivationalKey),
    ref: "signaturePad",
    attrs: {
      "id": "signature",
      "options": {
        onBegin: _vm.onBegin
      }
    }
  }), _c('span', {
    staticClass: "signLine unselectable"
  })], 1), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "pt-1"
  }, [_vm._v(" " + _vm._s(_vm.locationText) + " ")]), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "left": "",
      "nudge-left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "mr-6",
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": _vm.clear
          }
        }, on), [_c('v-icon', [_vm._v(" mdi-redo-variant ")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("sign.Sign.clear")))])])], 1)])])], 1), _c('v-checkbox', {
    ref: "terms",
    attrs: {
      "dense": "",
      "label": _vm.$t('sign.Sign.confirmationTerms'),
      "rules": [function (v) {
        return !!v || _vm.$t('sign.Sign.readTerms');
      }],
      "data-test-terms-checkbox": ""
    },
    model: {
      value: _vm.terms,
      callback: function callback($$v) {
        _vm.terms = $$v;
      },
      expression: "terms"
    }
  }), _c('v-checkbox', {
    ref: "withdrawal",
    attrs: {
      "dense": "",
      "label": _vm.$t('sign.Sign.confirmationWithdrawal'),
      "rules": [function (v) {
        return !!v || _vm.$t('sign.Sign.readWithdrawal');
      }],
      "data-test-withdrawal-checkbox": ""
    },
    model: {
      value: _vm.withdrawal,
      callback: function callback($$v) {
        _vm.withdrawal = $$v;
      },
      expression: "withdrawal"
    }
  })], 1)], 1), _vm.document ? _c('v-card-actions', {
    staticClass: "pt-2 pb-2 pl-4 pr-4"
  }, [_vm.currentStep === 1 && _vm.hasEditableTokens ? _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "elevation": 0,
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.sheet = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.cancel")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "success",
      "disabled": !!_vm.tokenListErrors
    },
    on: {
      "click": function click($event) {
        _vm.currentStep = 2;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("next")) + " ")])], 1) : _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "elevation": 0,
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        _vm.hasEditableTokens ? _vm.currentStep = 1 : _vm.sheet = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.hasEditableTokens ? _vm.$t("back") : _vm.$t("common.verbs.cancel")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "success",
      "disabled": !_vm.isValid || !_vm.isSigned,
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.submit")) + " ")])], 1)]) : _vm._e()], 1)], 1), _vm.row ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "elevation": 0,
      "outlined": "",
      "loading": _vm.isGenerationLoading
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("common.verbs.download")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "success",
      "disabled": _vm.isSignDisabled
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.submit")) + " ")])], 1)], 1) : _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "elevation": 0,
      "outlined": "",
      "loading": _vm.isGenerationLoading
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.SignFormEditorControls.download")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "success",
      "disabled": _vm.isSignDisabled
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.SignFormEditorControls.title")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }